module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid2_600x481.2dbcd34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid2_600x481.jpg
// module id = GnD2
// module chunks = 0